<template>
  <LMarker
    :lat-lng="[marker.latitude, marker.longitude]"
    @click="$emit('click', $event)"
    class="leaply marker"
    :key="`map-marker-${marker.id}`"
    ref="marker"
  >
    <l-icon
      :icon-url="image"
      :icon-anchor="[size / 2, size]"
      :icon-size="[size, size]"
      class-name="map-marker"
      :popup-anchor="[0, -size]"
    />
    <l-popup v-if="popup" :key="`map-marker-popup-${marker.id}`" ref="popup">
      <slot name="popup"></slot>
    </l-popup>
  </LMarker>
</template>

<script>
// Components
import { LIcon, LMarker, LPopup } from 'vue2-leaflet'

// Helpers
import _ from 'lodash'

export default {
  components: { LIcon, LMarker, LPopup },

  props: {
    marker: { type: Object, required: true },
    small: { type: Boolean, default: false },
    medium: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
    popup: { type: Boolean, default: false },
    image: { type: String, default: '/img/map-marker.png' },
  },

  data() {
    return {
      sizes: { small: 30, medium: 50, large: 70 },
    }
  },

  computed: {
    popupTrigger() {
      return _.get(this, '$route.query.popup')
    },
    mapVisibilityTrigger() {
      return _.get(this, '$route.query.showMap')
    },
    size() {
      const size = Object.keys(this.sizes).find(key => this[key])
      return size ? this.sizes[size] : this.sizes.medium
    },
  },

  watch: {
    mapVisibilityTrigger: {
      handler(visible) {
        if (visible && this.$refs['popup']) this.$refs['popup'].mapObject.update()
      },
    },
    popupTrigger: {
      immediate: true,
      handler(popup, oldPopup) {
        if (Number(popup) !== Number(oldPopup) && Number(popup) === this.marker.id) this.openPopup()
      },
    },
  },

  methods: {
    openPopup() {
      this.$nextTick(() => {
        if (!_.get(this, '$refs.marker.mapObject.openPopup')) return
        this.$refs.marker.mapObject.openPopup()
      })
    },
  },
}
</script>

<style lang="scss">
.leaply.map {
  .leaflet-popup {
    padding-top: 2rem;
  }
}
</style>
